import { IEigentuemerwechselResponseBody, IEigentuemerwechselBody } from "../../store/slices/eigentuemerwechsel";
import { ISepaUserData } from "../../store/slices/sepa";
import { adminInstance, instance, userInstance } from "../api";

const create = (data: IEigentuemerwechselBody) => {
  return instance.post("/eigentuemerwechsel", data).then((res) => res.data);
};

const getAdminEigentuemerwechselData = ({
  signal,
  direction,
  endDate,
  page,
  pageSize,
  payerType,
  searchValue,
  sort,
  startDate,
  status,
}: {
  sort?: string;
  direction?: string;
  searchValue?: string;
  page?: number;
  pageSize?: number;
  signal: AbortSignal;
  startDate?: Date | null | string;
  endDate?: Date | null | string;
  status?: string[];
  payerType?: string[];
}) => {
  return adminInstance
    .get<{ data: IEigentuemerwechselResponseBody[]; totalCount: number }>("/admin/eigentuemerwechsel", {
      params: {
        direction,
        endDate,
        page,
        pageSize,
        payerType,
        searchValue,
        sort,
        startDate,
        status,
      },
      signal,
    })
    .then((res) => res.data);
};

const getAdminEigentuemerwechselItemById = (id: string) => {
  return adminInstance
    .get<IEigentuemerwechselResponseBody>(`/admin/eigentuemerwechsel/${id}`)
    .then((res) => res.data);
};

const geEigentuemerwechselDoc = (id: string) => {
  return adminInstance
    .get(`/admin/eigentuemerwechsel/${id}/pdf`, {
      responseType: "blob",
    })
    .then((res) => {
      const href = URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", `Eingetuemerwechsel.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
};

const checkRegulierer = ({ objektId }: { objektId: string | number }) => {
  return userInstance
    .get<{
      isReguliererPresent: boolean;
      number: null | number;
      user?: ISepaUserData;
    }>(`/eigentuemerwechsel/address-data`, {
      params: {
        objektId,
      },
    })
    .then((res) => res.data);
};

const Eigentuemerwechsel = {
  get: {
    getAdminEigentuemerwechselData,
    getAdminEigentuemerwechselItemById,
    geEigentuemerwechselDoc,
    checkRegulierer,
  },
  post: {
    create,
  },
};

export default Eigentuemerwechsel;
